module.exports = __webpack_public_path__ + "static/footer-e4c9ae3e22bfbddc9b9029a75fa55870.jpg";